import CrudPage from "./CrudPage";

const Workshops = () => (
  <CrudPage
    title="Workshops"
    resource="workshops"
    testId="admin-workshops"
    columns={[
      { key: "title", label: "Titel" },
      { key: "date", label: "Datum" },
      { key: "location", label: "Ort" },
      { key: "price", label: "Preis CHF" },
      { key: "status", label: "Status" },
    ]}
    fields={[
      { key: "title", label: "Titel", required: true },
      { key: "description", label: "Beschreibung", type: "textarea", full: true },
      { key: "date", label: "Datum", type: "date", required: true },
      { key: "time", label: "Uhrzeit" },
      { key: "location", label: "Ort", required: true },
      { key: "teacher", label: "Lehrperson" },
      { key: "price", label: "Preis CHF", type: "number", required: true },
      { key: "teacher_share", label: "Anteil Lehrer", type: "number" },
      { key: "academy_share", label: "Anteil Academy", type: "number" },
      { key: "max_participants", label: "Max. Teilnehmer", type: "number" },
      { key: "registration_deadline", label: "Anmeldeschluss", type: "date" },
      { key: "language", label: "Sprache" },
      { key: "status", label: "Status", type: "select", options: [{ value: "open", label: "Offen" }, { value: "full", label: "Ausgebucht" }, { value: "closed", label: "Abgeschlossen" }] },
      { key: "image", label: "Bild URL", full: true },
    ]}
    defaults={{ title: "", description: "", date: "", time: "", location: "", teacher: "", price: 0, teacher_share: 0, academy_share: 0, max_participants: 0, registration_deadline: "", language: "Deutsch", status: "open", image: "" }}
  />
);

export default Workshops;
